import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";

export const useCreateCommunityDrawerViewModel = () => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { navigate } = useRouter();

  const createCommunity = (data) => {
    stateManager.run(async () => {
      const response = await homeService.communities.createCommunity({
        data,
        toastMessageConfig: {
          success: { text: `New community ${data.name} was created.` },
        },
      });

      if (response.status === HTTP_STATUSES.CREATED) {
        navigate(`/communities/${response.data.id}`);
      }
    });
  };

  return {
    isLoading,
    createCommunity,
  };
};
